export enum CookieKeys {
    DOCTOR_SELECTED = "SI_A_DOC_SELEC",
    CLINIC_SELECTED = "SI_A_CLI_SELEC",
}